import * as React from 'react';
import style from './SearchBox.scss';
import { SearchResults } from './SearchResults/index';
import { SearchBar } from './SearchBar';
import classnames from 'classnames';
import { SearchResultsEmptyState } from './SearchResults/SearchResultsEmptyState/index';
import { SEARCH_USER_ACTIONS } from '../../../LoggerFactory/BiAnalyticsLogger/events/consts';
import { Loader } from 'wix-style-react';
import { IResult } from './SearchResults/Result';

export const SearchBox = ({
  closeModal,
  sendBiEvents,
  searchResults,
  setSearchTerm,
  searchTerm,
  isFetchingResults,
  relatedSitesMap,
}: {
  closeModal: () => void;
  sendBiEvents: (userAction: any, chosenArticleLink?: string) => void;
  searchResults: IResult[];
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
  searchTerm: string;
  isFetchingResults: boolean;
  relatedSitesMap: Map<string, string>;
}) => {
  const hasResults = searchResults.length > 0;
  return (
    <div
      className={classnames({
        [style.searchBoxContainer]: true,
        [style.withResults]: hasResults,
      })}
    >
      <SearchBar
        setSearchTerm={setSearchTerm}
        searchTerm={searchTerm}
        onXButtonClick={onXButtonClick}
      />
      {isFetchingResults ? (
        <span className={style.loader} data-hook="search-loader">
          <Loader size="small" />
        </span>
      ) : (
        hasResults && (
          <SearchResults
            onSearchResultClick={onSearchResultClick}
            searchResults={searchResults}
            relatedSitesMap={relatedSitesMap}
          />
        )
      )}
      {shouldShowEmptyState() && (
        <SearchResultsEmptyState searchTerm={searchTerm} />
      )}
    </div>
  );

  function onSearchResultClick(chosenArticle) {
    return () => {
      sendBiEvents(SEARCH_USER_ACTIONS.RESULT_CLICK, chosenArticle);
      closeModal();
    };
  }

  function onXButtonClick() {
    sendBiEvents(SEARCH_USER_ACTIONS.CLEAR_BUTTON_CLICK);
  }

  function shouldShowEmptyState() {
    return !isFetchingResults && !hasResults && searchTerm?.length > 1;
  }
};
